import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import axiosInstance from '../services/axiosInstance';

const TokenValidator = ({ children }: { children: React.ReactNode }) => {
  const [isValid, setIsValid] = useState(true);
  const { logout } = useAuthStore();

  useEffect(() => {
    const validateToken = async () => {
      try {
        await axiosInstance.get('/protected');
      } catch {
        setIsValid(false);
        logout();
      }
    };
    validateToken();
  }, [logout]);

  if (!isValid) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default TokenValidator;
